import ResourceLocation from './ResourceLocation';

export default ResourceLocation;
